module.exports = __webpack_public_path__ + "static/media/move_icon_green_button.13771ed7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invitations/move_icon_green_button.svg
// module id = 898
// module chunks = 68